import { create } from "zustand";

export type ToastType = "error" | "success" | "info";

type Toast = {
  id: number;
  message: string;
  type: ToastType;
};

type ToastStore = {
  toasts: Toast[];
  showToast: (message: string, type?: ToastType) => void;
  removeToast: (id: number) => void;
};

let nextId = 1;

const useToastStore = create<ToastStore>((set, get) => ({
  toasts: [],
  showToast: (message, type = "error") => {
    // 같은 메시지가 이미 떠 있으면 중복 표시하지 않음 (병렬 요청 동시 실패 대비)
    if (get().toasts.some(toast => toast.message === message)) return;
    const id = nextId;
    nextId += 1;
    set(state => ({ toasts: [...state.toasts, { id, message, type }] }));
    setTimeout(() => get().removeToast(id), 4000);
  },
  removeToast: id =>
    set(state => ({ toasts: state.toasts.filter(toast => toast.id !== id) })),
}));

export default useToastStore;
